import {Property} from "../../../app/models/property";
import MyDealsNoProperties from "../../../app/components/MyDealsNoProperties";
import MyDealsNoPropertiesButHasRFPs from "../../../app/components/MyDealsNoPropertiesButHasRFPs";
import LoaderWithLinearProgress from "../../../app/components/LoaderWithLinearProgress";

interface Props {
  properties: Property[];
  rfps: any;
  loading: boolean;
  children?: React.ReactNode; // Add children
}

const DealList = ({ properties, rfps, loading, children }: Props) => {
  if (loading) return <LoaderWithLinearProgress />;

  return (
    <>
      {children}
      {properties.length === 0 && rfps.length === 0 && <MyDealsNoProperties />}
      {properties.length === 0 && rfps.length > 0 && <MyDealsNoPropertiesButHasRFPs />}
    </>
  );
};

export default DealList;
